import { SERVER_API_PATH } from "api/api-constants";
import { serverApi } from "api/api-server-actions";
import type { ForumClassicTimelineImportResult } from "types/forum-classic-import";
import { withApiErrorReporting } from "utils/api-errors";

export async function serverIngestTopic(sectionId: string, file: File): Promise<void> {
  return withApiErrorReporting("serverIngestTopic", async () => {
    const formData = new FormData();
    formData.append("section_id", sectionId);
    formData.append("file", file);
    await serverApi.post(`${SERVER_API_PATH}/ingestion/ingestions/`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  });
}

export async function serverIngestForumClassicTimeline(
  sectionId: string,
  file: File,
): Promise<ForumClassicTimelineImportResult> {
  return withApiErrorReporting("serverIngestForumClassicTimeline", async () => {
    const formData = new FormData();
    formData.append("section_id", sectionId);
    formData.append("file", file);
    const response = await serverApi.post<ForumClassicTimelineImportResult>(
      `${SERVER_API_PATH}/ingestion/ingestions/forum-classic-timeline/`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
    return response.data;
  });
}
